import { useEffect, useRef, useState } from "react";

export default function TextAnswer({ text, index }) {
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  const t = (text ?? "").trim();

  const LONG = 220; // justera
  const isLong = t.length > LONG;

  if (!t) return null;

  return (
    <div className={"textAnswerCard"}>
      <div className="textAnswerMeta">Svar {index + 1}</div>

       <div className={`textAnswerContent ${expanded ? "open" : ""}`}>
        {isLong && !expanded ? (
          <div ref={contentRef} className="textAnswerInner">
            {t.slice(0, LONG)}…
          </div>
        ) : (
          <div ref={contentRef} className="textAnswerInner">
            {t}
          </div>
        )}
      
      {isLong && (
        <div
          className="textAnswerToggle"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {/* <span>{expanded ? "Visa mindre" : "Läs mer"}</span> */}
          <i className={`arrowexp ${expanded ? "up" : "down"}`}></i>
          
        </div>
      )}</div>
    </div>
  );
}
